import * as React from 'react';
import { PaginatedContext, ContextValue } from '../components/management/pagination/paginated-context';
import Revision from '../models/revision';

const defaultState: PaginatedContext<Revision> = {
  loading: false,
  results: [],
  currentPage: 1,
  totalResults: 0,
  pageSize: 60,
  orderDirection: null,
  orderColumn: '',
  searchTerm: null
};

/** Context for sharing revisions results to be displayed in a paginated form */
const PaginatedRevisionsContext = React.createContext<ContextValue<Revision>>(null);

const PaginatedRevisionsConsumer = PaginatedRevisionsContext.Consumer;

const PagedRevisionsProvider = props => {
  const [state, setState] = React.useState<PaginatedContext<Revision>>(defaultState);

  const dispatch = (newValue: any) => {
    setState(prevState => {
      return { ...prevState, ...newValue };
    });
  };

  return (
    <PaginatedRevisionsContext.Provider value={{ ...state, dispatch }}>
      {props.children}
    </PaginatedRevisionsContext.Provider>
  );
};

export { PaginatedRevisionsContext, PagedRevisionsProvider, PaginatedRevisionsConsumer };
